(() => {
  if (window.foodyHeaderInitialized) return;
  window.foodyHeaderInitialized = true;

  function setMenu(root, open, restoreFocus = false) {
    const menu = root.querySelector('.mobile-menu');
    const button = root.querySelector('.menu-toggle');
    if (!menu || !button) return;
    menu.classList.toggle('open', open);
    menu.inert = !open;
    button.setAttribute('aria-expanded', String(open));
    button.setAttribute('aria-label', open ? button.dataset.closeLabel : button.dataset.openLabel);
    if (restoreFocus) button.focus();
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('[data-foody-header]').forEach((root) => {
      const search = event.target.closest('.foody-header-search');
      const dialog = root.querySelector('.foody-search-dialog');
      if (search && root.contains(search) && dialog) { event.preventDefault(); setMenu(root, false); dialog.showModal(); dialog.querySelector('input').focus(); }
      if (dialog && (event.target.closest('[data-foody-search-close]') || event.target === dialog)) dialog.close();
      const toggle = event.target.closest('.menu-toggle');
      if (toggle && root.contains(toggle)) {
        setMenu(root, toggle.getAttribute('aria-expanded') !== 'true');
      } else if (!root.contains(event.target) || event.target.closest('.mobile-menu a')) {
        setMenu(root, false);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-foody-header]').forEach((root) => {
      if (root.querySelector('.mobile-menu.open')) setMenu(root, false, root.contains(document.activeElement));
    });
  });

  matchMedia('(min-width: 1000px)').addEventListener('change', () => {
    document.querySelectorAll('[data-foody-header]').forEach((root) => setMenu(root, false));
  });

  async function updateCartCount() {
    const root = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (!Number.isInteger(cart.item_count)) return;
      document.querySelectorAll('[data-foody-cart-count]').forEach((count) => {
        count.textContent = String(cart.item_count);
      });
    } catch {}
  }

  document.addEventListener('cart:update', updateCartCount);
  document.addEventListener('foody:cart-added', updateCartCount);
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) updateCartCount();
  });
})();
// Nested navigation: hover on desktop, native details toggles for touch and keyboard.
(() => {
  if (window.foodySubmenusInitialized) return;
  window.foodySubmenusInitialized = true;
  const desktop = matchMedia('(min-width:1000px)');
  const close = (except) => document.querySelectorAll('[data-foody-submenu][open]').forEach(el => { if(el !== except) el.open = false; });
  document.addEventListener('pointerover', event => {
    if (!desktop.matches || event.pointerType === 'touch') return;
    const group = event.target.closest('.desktop-nav [data-foody-submenu]');
    if(group){close(group);group.open=true;}
    else if(event.target.closest('.desktop-nav')) close();
  });
  document.addEventListener('pointerout', event => {
    if(!desktop.matches || event.pointerType === 'touch') return;
    const group=event.target.closest('.desktop-nav [data-foody-submenu]');
    if(group && !group.contains(event.relatedTarget)) group.open=false;
  });
  document.addEventListener('toggle', event => {if(event.target.matches?.('[data-foody-submenu]') && event.target.open) close(event.target);},true);
  document.addEventListener('click', event => {if(!event.target.closest('[data-foody-submenu]')) close();});
  document.addEventListener('focusin', event => {if(!event.target.closest('[data-foody-submenu]')) close();});
  document.addEventListener('keydown', event => {if(event.key==='Escape'){const group=document.activeElement.closest('[data-foody-submenu]');close();group?.querySelector('summary').focus();}});
  desktop.addEventListener('change',()=>close());
})();

(() => {
 const states = new WeakMap();
 document.addEventListener('input', event => {
  const input = event.target.closest('.foody-search-bar input[name="q"]'); if (!input) return;
  const dialog = input.closest('dialog'), results = dialog.querySelector('[data-search-results]'), status = dialog.querySelector('[data-search-status]');
  let state = states.get(dialog); if (!state) { state = { initial: results.innerHTML }; states.set(dialog, state); }
  clearTimeout(state.timer); state.controller?.abort(); state.version = (state.version || 0) + 1; const version = state.version;
  const query = input.value.trim(); status.textContent = ''; results.removeAttribute('aria-busy');
  if (!query) { results.innerHTML = state.initial; return; }
  state.timer = setTimeout(async () => {
   state.controller = new AbortController(); results.setAttribute('aria-busy', 'true');
   const zh = document.documentElement.lang.startsWith('zh'); status.textContent = zh ? '搜索中…' : 'Searching…';
   try {
    const params = new URLSearchParams({q: query, 'resources[type]': 'product', 'resources[limit]': '4', section_id: 'foody-predictive-search'});
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'search/suggest?' + params, {signal: state.controller.signal});
    if (!response.ok) throw new Error('search');
    const html = await response.text(); if (state.version !== version) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html'); const section = parsed.querySelector('#shopify-section-foody-predictive-search');
    if (!section) throw new Error('search'); results.innerHTML = section.innerHTML; status.textContent = '';
   } catch(error) { if (error.name !== 'AbortError' && state.version === version) { results.replaceChildren(); status.textContent = zh ? '暂时无法加载，请按回车查看搜索结果。' : 'Unable to load. Press Enter to view search results.'; } }
   finally { if (state.version === version) results.removeAttribute('aria-busy'); }
  }, 250);
 });
})();

(()=>{if(window.foodyAnnouncementInit)return;window.foodyAnnouncementInit=true;function init(scope){if(!window.Swiper)return;scope.querySelectorAll('[data-announcements]').forEach(el=>{if(el.swiper)return;new Swiper(el,{slidesPerView:1,loop:el.querySelectorAll('[data-announcement]').length>1,speed:400,autoplay:matchMedia('(prefers-reduced-motion:reduce)').matches?false:{delay:Number(el.dataset.delay)||5000,disableOnInteraction:false,pauseOnMouseEnter:true},navigation:{prevEl:el.querySelector('[data-ann-prev]'),nextEl:el.querySelector('[data-ann-next]')},a11y:{enabled:true}});el.addEventListener('focusin',()=>el.swiper.autoplay?.stop());el.addEventListener('focusout',()=>{if(!matchMedia('(prefers-reduced-motion:reduce)').matches)el.swiper.autoplay?.start()})})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);document.addEventListener('shopify:section:load',e=>init(e.target));document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-announcements]').forEach(el=>el.swiper?.destroy(true,true)));document.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('[data-announcement]'),sw=slide?.closest('[data-announcements]')?.swiper;if(sw){sw.autoplay?.stop();sw.slideToLoop(Number(slide.dataset.swiperSlideIndex)||0)}})})();